import Vue from "vue";
import Router from "vue-router";
import CryptoJS from "crypto-js";
import store from "@/store";

import Dashboard from "@/views/dashboard/Dashboard";

import Kpi from "@/views/kpi/Kpi.vue";
import CreateKpi from "@/views/kpi/create/Create.vue";

import LandingCuti from "@/views/cuti/Cuti";
import ManifestCuti from "@/views/cuti/Manifest";
import PublicManifestCuti from "@/views/cuti/ManifestApproval";

import Alokasi from "@/views/absensi/alokasi/Alokasi";
import CreateAlokasi from "@/views/absensi/alokasi/Create";
import ManifestAlokasi from "@/views/absensi/alokasi/Manifest";
import ManifestApprovalAlokasi from "@/views/absensi/alokasi/ManifestApproval";

import MasterKaryawan from "@/views/master/karyawan/Index";
import ListKaryawan from "@/views/master/karyawan/ListKaryawan";

import MasterSiswa from "@/views/master/siswa/Index";
import ListSiswa from "@/views/master/siswa/ListSiswa";

import IndexKalender from "@/views/master/kalender/Index";
import MasterKalender from "@/views/master/kalender/MKalender";

import MasterBirthday from "@/views/master/birthday/index";

import MasterIssue from "@/views/master/issue/Index";

import LandingKaryawan from "@/views/profile/Index";
import ProfileKaryawan from "@/views/profile/Profile";
import DokumenKaryawan from "@/views/profile/Dokumen";
import KepegawaianKaryawan from "@/views/profile/Kepegawaian";
import AnggotaKeluargaKaryawan from "@/views/profile/Anggota";
import PlafonKesehatanView from "@/views/profile/Plafon_kesehatan";
import BPJSKaryawan from "@/views/profile/BPJSKaryawan";
import FasilitasKerja from "@/views/profile/FasilitasKerja";
import CutiKaryawan from "@/views/profile/Cuti";

import LandingSiswa from "@/views/master/siswa/profile/Index";
import ProfileSiswa from "@/views/master/siswa/profile/Profile";
import DokumenSiswa from "@/views/master/siswa/profile/Dokumen";
import KegiatanSiswa from "@/views/master/siswa/profile/Kegiatan";

import MonAlokasi from "@/views/spesialmenu/monitoring/alokasi/MonAlokasi";

import ListMonitoringCuti from "@/views/spesialmenu/monitoring/cuti/MonCuti";
import indexMonitoring from "@/views/spesialmenu/monitoring/index";

import MonSisaCuti from "@/views/spesialmenu/monitoring/cuti/MonSisaCuti";

import KaryawanBaru from "@/views/master/karyawan/create/CreateKaryawan";
import SiswaBaru from "@/views/master/siswa/create/CreateSiswa";

import IndexKategori from "@/views/master/kategori/Index";
import MasterKategori from "@/views/master/kategori/MKategori";

// Begin rekap alokasi
import MonrAlokasi from "@/views/spesialmenu/monitoring/rekapAlokasi/MonRekapAlokasi";
import IndexRaLokasi from "@/views/spesialmenu/monitoring/rekapAlokasi/Index";
import ManifestrAlokasi from "@/views/spesialmenu/monitoring/rekapAlokasi/Manifest";
// end rekap alokasi

// Begin Mon Absensi
import IndexMonAbsensi from "@/views/spesialmenu/monitoring/absensi/Index";
import MonAbsensi from "@/views/spesialmenu/monitoring/absensi/MonAbsensi";
// end rekap alokasi

// Begin Log Absensi
import IndexLogAbsensi from "@/views/absensi/logKehadiran/Index";
import LogAbsensi from "@/views/absensi/logKehadiran/LogKehadiran";
// end Log Absensi

// Begin Mon Prorasi
import IndexMonProrasi from "@/views/spesialmenu/monitoring/prorasi/Index";
import MonProrasi from "@/views/spesialmenu/monitoring/prorasi/MonProrasi";
// end Prorasi

// Begin Handle View
import P404 from "@/views/handleView/404.vue";
// import PNoCon from '@/views/handleView/noConnection.vue'
// End HAndle View

// Klaim Kesehatan
import MasterPelayanan from "@/views/klaimKesehatan/pelayanan/index";

import KlaimLayout from "@/views/klaimKesehatan/klaim/index";
import KlaimKesehatan from "@/views/klaimKesehatan/klaim/list";
import CreateKlaim from "@/views/klaimKesehatan/klaim/create";
import ManifestKlaim from "@/views/klaimKesehatan/klaim/manifest";
import MonitoringKlaim from "@/views/klaimKesehatan/monitoring/index";
import MonitoringKlaimList from "@/views/klaimKesehatan/monitoring/list";
import MonitoringKlaimCreate from "@/views/klaimKesehatan/monitoring/create";
import RekapKlaimDokter from "@/views/klaimKesehatan/rekap/List";
import RekapKlaimDokterManifest from "@/views/klaimKesehatan/rekap/Manifest";

import IndexAbsenPhoto from "@/views/absensi/takePhotoLive/Index";
import AbsenPhoto from "@/views/absensi/takePhotoLive/Takephoto";

import ListSPL from "@/views/lembur/spl/List";
import CreateSPL from "@/views/lembur/spl/Create";
import manifestSpl from "@/views/lembur/spl/Manifest.vue";
import ManifestApprovalSPL from "@/views/lembur/spl/ManifestApproval.vue";

import ListRealisasiSPL from "@/views/lembur/realisasiSPL/List";
import CreateRealisasiSPL from "@/views/lembur/realisasiSPL/Create";
import manifestRealisasiSpl from "@/views/lembur/realisasiSPL/Manifest.vue";
import ManifestApprovalrealisasiSPL from "@/views/lembur/realisasiSPL/ManifestApproval.vue";

import ListRekapRealisasiSPL from "@/views/lembur/rekap/List";
import ManifestRekapRealisasiSPL from "@/views/lembur/rekap/Manifest";

import listRekapRealisasiTarifSpl from "@/views/lembur/rekapTarif/list";
import manifestRekapRealisasiTarifSpl from "@/views/lembur/rekapTarif/manifest";
import layoutRekap from "@/views/lembur/Index.vue";

import DashboardHrd from "@/views/spesialmenu/monitoring/dashboard/Dashboard";
import monitoringVisitorCard from "@/views/spesialmenu/monitoring/visitorCard/index.vue";

// Component Wrapper
const Wrapper = () =>
  import(
    /* webpackChunkName: "wrapper-page" */ "@/components/wrapper/Administrator.vue"
  );

// Begin Administrator Page
const Admin = () =>
  import(/* webpackChunkName: "admin-page" */ "@/views/admin/index.vue");

const MasterIntervalWorkflow = () =>
  import(
    /* webpackChunkName: "master-interval-workflow-page" */ "@/views/admin/intervalWorkflow.vue"
  );

const ChangeLogs = () =>
  import(
  /* webpackChunkName: "ChangeLogs" */ "@/components/ChangeLogs.vue"
  );

const ReferralFrom = () =>
  import(
    /* webpackChunkName: "ReferralFrom" */ "@/components/ReferralFrom.vue"
  );

Vue.use(Router);

const isAuthenticated = (to, from, next) => {
  let url = to.path.split("/");
  if (to.name == "404" && url.length >= 5 && url[2] == "login") {
    if (localStorage.getItem("key_") === null) {
      localStorage.setItem("key_", url[4]);
    } else {
      localStorage.removeItem("key_");
      localStorage.setItem("key_", url[4]);
    }
  }
  let auth = "";
  try {
    let b64 = CryptoJS.enc.Base64.parse(localStorage.getItem("key_"));
    let sVal = CryptoJS.enc.Utf8.stringify(b64);
    auth = JSON.parse(sVal);

    store.dispatch("SET_AUTH", auth);
    store.dispatch("FETCH_USER_ACCESS", auth.message.tlc);
    store.dispatch("SET_ISLOGIN", auth.status);
  } catch (e) {
    localStorage.removeItem("key_");
  }

  if (store.getters.getIsLogin && url[2] == "login") {
    next("/");
    return;
  }

  if (store.getters.getIsLogin) {
    next();
    return;
  }

  window.location = process.env.VUE_APP_PANDAPAKITA;
};

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      name: "404",
      component: P404,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/login/:string/:id",
      name: "LoginProcess",
      props: true,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem("key_") === null) {
          localStorage.setItem("key_", to.params.id);
        } else {
          localStorage.removeItem("key_");
          localStorage.setItem("key_", to.params.id);
        }

        next("/");
      },
    },
    {
      path: "/kpi",
      name: "kpi",
      component: Kpi,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/kpi/create",
      name: "kpiCreate",
      component: CreateKpi,
      beforeEnter: isAuthenticated,
    },
    {
      path: "",
      name: "dashboard",
      component: Dashboard,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/cuti",
      name: "landingCuti",
      component: LandingCuti,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/cuti/manifest/:id",
      name: "manifestCuti",
      props: true,
      component: ManifestCuti,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/klaim-kesehatan",
      name: "klaimKesehatan",
      component: KlaimLayout,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "list",
          name: "listKlaim",
          props: true,
          component: KlaimKesehatan,
        },
        {
          path: "create",
          name: "createKlaim",
          props: true,
          component: CreateKlaim,
        },
        {
          path: "manifest/:id",
          name: "manifestKlaim",
          props: true,
          component: ManifestKlaim,
        },
        {
          path: "revise/:id",
          name: "reviseKlaim",
          props: true,
          component: CreateKlaim,
        },
      ],
    },
    {
      path: "/alokasi",
      name: "alokasiPekerjaan",
      component: Alokasi,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/alokasi-manager",
      name: "alokasiManager",
      component: () =>
        import(
          /* webpackChunkName: "alokasi-manager" */ "../views/absensi/manager/Alokasi.vue"
        ),
      beforeEnter: isAuthenticated,
    },
    {
      path: "/alokasi/create",
      name: "create.alokasi",
      props: true,
      component: CreateAlokasi,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/alokasi/:id",
      name: "edit.alokasi",
      props: true,
      component: CreateAlokasi,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/alokasi/draft/:id",
      name: "draft.alokasi",
      props: true,
      component: CreateAlokasi,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/alokasi/manifest/:id",
      name: "manifest.alokasi",
      props: true,
      component: ManifestAlokasi,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/karyawan/:tlc",
      props: true,
      component: LandingKaryawan,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "profile",
          name: "profile",
          props: true,
          component: ProfileKaryawan,
        },
        {
          path: "dokumen",
          name: "dokumen",
          props: true,
          component: DokumenKaryawan,
        },
        {
          path: "kepegawaian",
          name: "kepegawaian",
          props: true,
          component: KepegawaianKaryawan,
        },
        {
          path: "anggota",
          name: "anggota",
          props: true,
          component: AnggotaKeluargaKaryawan,
        },
        {
          path: "plafon_kesehatan",
          name: "plafon_kesehatan",
          props: true,
          component: PlafonKesehatanView,
        },
        {
          path: "bpjs",
          name: "bpjs",
          props: true,
          meta: {
            isHRD: false,
          },
          component: BPJSKaryawan,
        },
        {
          path: "fasilitasKerja",
          name: "fasilitasKerja",
          props: true,
          meta: {
            isHRD: false,
          },
          component: FasilitasKerja,
        },
        {
          path: "cuti",
          name: "cuti",
          props: true,
          component: CutiKaryawan,
        },
      ],
    },
    {
      path: "/logAbsensi",
      props: true,
      component: IndexLogAbsensi,
      beforeEnter: isAuthenticated,
      meta: {
        layoutNonScroll: false,
      },
      children: [
        {
          path: "",
          name: "log.absensi",
          props: true,
          component: LogAbsensi,
        },
      ],
    },
    {
      path: "/absenPhoto",
      props: true,
      component: IndexAbsenPhoto,
      beforeEnter: isAuthenticated,
      meta: {
        layoutNonScroll: false,
      },
      children: [
        {
          path: "",
          name: "absenPhoto",
          props: true,
          component: AbsenPhoto,
        },
        {
          path: "test",
          name: "TestabsenPhoto",
          props: true,
          meta: {
            modetestlayar: true,
          },
          component: AbsenPhoto,
        },
      ],
    },
    {
      path: "/logout",
      name: "logout",
      props: true,
      beforeEnter: () => {
        localStorage.removeItem("key_");
        window.location = process.env.VUE_APP_PANDAPAKITA;
      },
    },
    {
      path: "/app",
      name: "app",
      props: true,
      beforeEnter: () => {
        localStorage.removeItem("key_");
        window.location = process.env.VUE_APP_PANDAPAKITA;
      },
    },
    {
      path: "/direktur/monitoring",
      name: "Direktur",
      component: indexMonitoring,
      props: { spesialFor: "Direktur", labelMenu: "Direktur" },
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "cuti",
          name: "direktur.mon.cuti",
          props: { spesialFor: "Direktur" },
          component: ListMonitoringCuti,
        },
        {
          path: "manifest/:id",
          name: "dir.mon.manifest.cuti",
          props: true,
          component: ManifestCuti,
        },
        {
          path: "alokasi",
          name: "dir.mon.alokasi",
          props: { spesialFor: "Direktur" },
          component: MonAlokasi,
        },
        {
          path: "/alokasi/manifest/:id",
          name: "dir.mon.manifest.alokasi",
          props: true,
          component: ManifestAlokasi,
          beforeEnter: isAuthenticated,
        },
        {
          path: "spclSpl",
          name: "spclSplDir",
          component: ListSPL,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "spclRealisasi-spl",
          name: "spclRealisasi-splDir",
          component: ListRealisasiSPL,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "manifestSplDir/:id",
          name: "manifestSplDir",
          props: true,
          component: manifestSpl,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "manifestRealisasiSplDir/:id",
          name: "manifestRealisasiSplDir",
          props: true,
          component: manifestRealisasiSpl,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "monAbsensi",
          props: true,
          component: IndexMonAbsensi,
          beforeEnter: isAuthenticated,
          meta: {
            layoutNonScroll: true,
          },
          children: [
            {
              path: "",
              name: "direktur.mon.absensi",
              props: true,
              component: MonAbsensi,
              meta: {
                isDirektur: true,
              },
            },
          ],
        },
        {
          path: "monAbsensiTLC",
          props: true,
          component: IndexMonAbsensi,
          beforeEnter: isAuthenticated,
          meta: {
            layoutNonScroll: true,
          },
          children: [
            {
              path: "",
              name: "direktur.log.absensi",
              meta: {
                isDirektur: true,
              },
              props: true,
              component: LogAbsensi,
            },
          ],
        },
      ],
    },
    {
      path: "/atasanlangsung/monitoring",
      name: "Atasan Langsung",
      component: indexMonitoring,
      props: { spesialFor: "Atasan Langsung", labelMenu: "Atasan Langsung" },
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "cuti",
          name: "al.mon.cuti",
          props: { spesialFor: "Atasan Langsung" },
          component: ListMonitoringCuti,
        },
        {
          path: "manifest/:id",
          name: "al.mon.manifest.cuti",
          props: true,
          component: ManifestCuti,
        },
        {
          path: "alokasi",
          name: "al.mon.alokasi",
          props: { spesialFor: "Atasan Langsung" },
          component: MonAlokasi,
        },
        {
          path: "/alokasi/manifest/:id",
          name: "al.mon.manifest.alokasi",
          props: true,
          component: ManifestAlokasi,
          beforeEnter: isAuthenticated,
        },
        {
          path: "absensi",
          name: "al.mon.absensi",
          props: true,
          meta: {
            isAL: true,
          },
          component: LogAbsensi,
        },
        {
          path: "spclSpl",
          name: "spclSplAL",
          component: ListSPL,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "spclRealisasi-spl",
          name: "spclRealisasi-splAL",
          component: ListRealisasiSPL,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "manifestSplAL/:id",
          name: "manifestSplAL",
          props: true,
          component: manifestSpl,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "manifestRealisasiSplAL/:id",
          name: "manifestRealisasiSplAL",
          props: true,
          component: manifestRealisasiSpl,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
      ],
    },

    {
      path: "/hrd/monitoring",
      name: "HRD",
      component: indexMonitoring,
      props: { spesialFor: "HRD", labelMenu: "HR Departemen" },
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "cuti",
          name: "hrd.mon.cuti",
          props: { spesialFor: "HRD" },
          component: ListMonitoringCuti,
        },
        {
          path: "manifestcuti/:id",
          name: "hrd.mon.manifest.cuti",
          props: true,
          component: ManifestCuti,
        },
        {
          path: "sisa_cuti",
          name: "hrd.mon.sisa_cuti",
          props: { spesialFor: "HRD" },
          component: MonSisaCuti
        },
        {
          path: "alokasi",
          name: "hrd.mon.alokasi",
          props: { spesialFor: "HRD" },
          component: MonAlokasi,
        },
        {
          path: "manifest/:id",
          name: "hrd.mon.manifest.alokasi",
          props: true,
          component: ManifestAlokasi,
          beforeEnter: isAuthenticated,
        },
        {
          path: "master/karyawan",
          props: true,
          component: MasterKaryawan,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "master.karyawan",
              props: true,
              component: ListKaryawan,
            },
            {
              path: ":tlc",
              name: "hrd.mon.karyawan",
              component: LandingKaryawan,
              props: true,
              beforeEnter: isAuthenticated,
              children: [
                {
                  path: "profile",
                  name: "hrd.karyawan.profile",
                  props: { spesialFor: "HRD" },
                  meta: { isHrd: "HRD" },
                  component: ProfileKaryawan,
                },
                {
                  path: "dokumen",
                  name: "hrd.karyawan.dokumen",
                  props: true,
                  component: DokumenKaryawan,
                },
                {
                  path: "kepegawaian",
                  name: "hrd.karyawan.kepegawaian",
                  props: true,
                  component: KepegawaianKaryawan,
                },
                {
                  path: "anggota",
                  name: "hrd.karyawan.anggota",
                  props: true,
                  component: AnggotaKeluargaKaryawan,
                },
                {
                  path: "plafon_kesehatan",
                  name: "hrd.karyawan.plafon_kesehatan",
                  props: true,
                  component: PlafonKesehatanView,
                },
                {
                  path: "bpjs",
                  name: "hrd.karyawan.bpjs",
                  props: true,
                  meta: {
                    isHRD: true,
                  },
                  component: BPJSKaryawan,
                },
                {
                  path: "fasilitasKerja",
                  name: "hrd.karyawan.fasilitasKerja",
                  props: true,
                  meta: {
                    isHRD: true,
                  },
                  component: FasilitasKerja,
                },
                {
                  path: "cuti",
                  name: "hrd.karyawan.cuti",
                  props: true,
                  component: CutiKaryawan,
                },
              ],
            },
          ],
        },
        {
          path: "master/birhtday",
          props: true,
          component: MasterBirthday,
          name: "master.birthday",
          beforeEnter: isAuthenticated,
        },
        {
          path: "master/siswa",
          props: true,
          component: MasterSiswa,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "master.siswa",
              props: true,
              component: ListSiswa,
            },
            {
              path: ":id_siswa",
              name: "hrd.mon.siswa",
              component: LandingSiswa,
              props: true,
              beforeEnter: isAuthenticated,
              children: [
                {
                  path: "profile",
                  name: "hrd.siswa.profile",
                  props: { spesialFor: "HRD" },
                  meta: { isHrd: "HRD" },
                  component: ProfileSiswa,
                },
                {
                  path: "dokumen",
                  name: "hrd.siswa.dokumen",
                  props: true,
                  component: DokumenSiswa,
                },
                {
                  path: "kegiatan",
                  name: "hrd.siswa.kegiatan",
                  props: true,
                  component: KegiatanSiswa,
                },
              ],
            },
          ],
        },
        {
          path: "master/kalender",
          props: true,
          component: IndexKalender,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              props: true,
              name: "master.kalender",
              component: MasterKalender,
            },
          ],
        },
        {
          path: "master/kategori",
          props: true,
          component: IndexKategori,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              props: true,
              name: "master.kategori",
              component: MasterKategori,
            },
          ],
        },
        {
          path: "master/issue",
          props: true,
          component: MasterIssue,
          name: "master.issue",
          beforeEnter: isAuthenticated,
        },
        {
          path: "rekap-beban-cost-center",
          props: true,
          component: () =>
            import(
              /* webpackChunkName: "beban-cost" */ "../views/costCenter/Index.vue"
            ),
          children: [
            {
              path: "",
              name: "bebanCostCenter",
              props: true,
              component: () =>
                import(
                  /* webpackChunkName: "beban-cost" */ "../views/costCenter/CostCenter.vue"
                ),
            },
            {
              path: "create-new",
              name: "create-bebanCostCenter",
              props: true,
              component: () =>
                import(
                  /* webpackChunkName: "create-beban-cost" */ "../views/costCenter/Create.vue"
                ),
            },
            {
              path: ":id/manifest",
              name: "manifest-bebanCostCenter",
              props: true,
              component: () =>
                import(
                  /* webpackChunkName: "manifest-beban-cost" */ "../views/costCenter/Manifest.vue"
                ),
            },
          ],
        },
        {
          path: "ralokasi",
          props: true,
          component: IndexRaLokasi,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "hrd.mon.ralokasi",
              props: true,
              component: MonrAlokasi,
            },
            {
              path: "manifest/:id",
              name: "hrd.mon.manifest.ralokasi",
              props: true,
              component: ManifestrAlokasi,
            },
          ],
        },
        {
          path: "monAbsensi",
          props: true,
          component: IndexMonAbsensi,
          beforeEnter: isAuthenticated,
          meta: {
            layoutNonScroll: true,
          },
          children: [
            {
              path: "",
              name: "hrd.mon.absensi",
              props: true,
              component: MonAbsensi,
              meta: {
                isHRD: true,
              },
            },
          ],
        },
        {
          path: "monAbsensiTLC",
          props: true,
          component: IndexMonAbsensi,
          beforeEnter: isAuthenticated,
          meta: {
            layoutNonScroll: true,
          },
          children: [
            {
              path: "",
              name: "hrd.log.absensi",
              meta: {
                isHRD: true,
              },
              props: true,
              component: LogAbsensi,
            },
          ],
        },
        {
          path: "/spclSpl",
          name: "spclSplHrd",
          component: ListSPL,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "/spclRealisasi-spl",
          name: "spclRealisasi-splHrd",
          component: ListRealisasiSPL,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "manifestSplHrd/:id",
          name: "manifestSplHrd",
          props: true,
          component: manifestSpl,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "manifestRealisasiSplHrd/:id",
          name: "manifestRealisasiSplHrd",
          props: true,
          component: manifestRealisasiSpl,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
        {
          path: "/rekapRealisasiSPL",
          name: "rekapRealisasiSPL",
          component: ListRekapRealisasiSPL,
          meta: {},
          beforeEnter: isAuthenticated,
        },
        {
          path: "/rekap-realisasi-tarif-SPL",
          name: "rekapRealisasiTarifSPL",
          component: listRekapRealisasiTarifSpl,
          meta: {},
          beforeEnter: isAuthenticated,
        },
        {
          path: "/rekap-realisasi-tarif-SPL/manifest/:id",
          name: "manifest_rekap_realisasi_lembur",
          component: manifestRekapRealisasiTarifSpl,
          props: true,
          meta: {},
          beforeEnter: isAuthenticated,
        },
        {
          path: "/manifestRekapRealisasiSPL/:id",
          name: "manifestRekapRealisasiSPL",
          props: true,
          component: ManifestRekapRealisasiSPL,
          meta: {},
          beforeEnter: isAuthenticated,
        },

        {
          path: "master/pelayanan",
          name: "master.pelayanan",
          props: true,
          component: MasterPelayanan,
          meta: {},
          beforeEnter: isAuthenticated,
        },

        {
          path: "klaim-kesehatan",
          name: "monitoring_klaim",
          props: true,
          meta: {
            isHRD: true,
          },
          component: MonitoringKlaim,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "list",
              name: "monitoring_klaim_list",
              props: true,
              component: MonitoringKlaimList,
            },
            {
              path: "create",
              name: "monitoring_klaim_create",
              props: true,
              component: MonitoringKlaimCreate,
            },
            {
              path: "manifest/:id",
              name: "monitoring_klaim_manifest",
              props: true,
              component: ManifestKlaim,
            },
            {
              path: "revise/:id",
              name: "monitoring_klaim_revise",
              props: true,
              component: MonitoringKlaimCreate,
            },
            {
              path: "rekap-dokter",
              name: "rekap_klaim_dokter",
              props: true,
              component: RekapKlaimDokter,
            },
            {
              path: "rekap-dokter/manifest/:id",
              name: "rekap_klaim_dokter_manifest",
              props: true,
              component: RekapKlaimDokterManifest,
            },
          ],
        },
        {
          path: "monProrasi",
          props: true,
          component: IndexMonProrasi,
          beforeEnter: isAuthenticated,
          meta: {
            layoutNonScroll: true,
          },
          children: [
            {
              path: "",
              name: "hrd.mon.prorasi",
              props: true,
              component: MonProrasi,
              meta: {
                hrd: true,
              },
            },
          ],
        },
        {
          path: "dashboard",
          name: "hrd.mon.dashboard",
          props: { spesialFor: "HRD" },
          component: DashboardHrd
        },
        {
          path: "visitor-card",
          name: "hrd.mon.vcard",
          component: monitoringVisitorCard,
          meta: {
            isSPCL: true,
          },
          beforeEnter: isAuthenticated,
        },
      ],
    },

    {
      path: "/karyawanbaru",
      name: "karyawanbaru",
      component: KaryawanBaru,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/karyawanbaru/rubah/:tlc",
      name: "karyawanrubah",
      component: KaryawanBaru,
      props: true,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/siswaBaru",
      name: "siswabaru",
      component: SiswaBaru,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/siswa/rubah/:tlc",
      name: "siswarubah",
      component: SiswaBaru,
      props: true,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/admin",
      beforeEnter: isAuthenticated,
      component: Wrapper,
      props: { spesialFor: "Administrator" },
      children: [
        {
          path: "",
          name: "Administrator",
          props: true,
          component: Admin,
        },
        {
          path: "master-interval-workflow",
          name: "master-interval-workflow",
          props: true,
          component: MasterIntervalWorkflow,
        },
        {
          path: "/monAbsensi",
          name: "admin.mon.absensi",
          props: true,
          component: MonAbsensi,
        },
      ],
    },
    {
      path: "/spl",
      name: "spl",
      component: ListSPL,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/spl/create",
      name: "createSPL",
      component: CreateSPL,
      meta: {
        isCreate: true,
      },
      beforeEnter: isAuthenticated,
    },
    {
      path: "/spl/edit/:id",
      name: "editSPL",
      component: CreateSPL,
      props: true,
      meta: {
        isCreate: false,
      },
      beforeEnter: isAuthenticated,
    },
    {
      path: "/spl/manifest/:id",
      name: "manifestSpl",
      props: true,
      component: manifestSpl,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/realisasi-spl",
      name: "realisasi-spl",
      component: ListRealisasiSPL,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/realisasi-spl/create",
      name: "createRealisasiSPL",
      component: CreateRealisasiSPL,
      meta: {
        isCreate: true,
      },
      beforeEnter: isAuthenticated,
    },
    {
      path: "/realisasi-spl/edit/:id",
      name: "editRealisasiSPL",
      component: CreateRealisasiSPL,
      props: true,
      meta: {
        isCreate: false,
      },
      beforeEnter: isAuthenticated,
    },
    {
      path: "/realisasi-spl/manifest/:id",
      name: "manifestRealisasiSpl",
      props: true,
      component: manifestRealisasiSpl,
      beforeEnter: isAuthenticated,
    },

    // public side
    {
      path: "/pu/cuti/:id",
      name: "publicManifestCuti",
      props: true,
      component: PublicManifestCuti,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/alokasi/:id",
      name: "ManifestApprovalAlokasi",
      props: true,
      component: ManifestApprovalAlokasi,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/spl/:id",
      name: "ManifestApprovalSPL",
      props: true,
      component: ManifestApprovalSPL,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/realisasi-spl/:id",
      name: "ManifestApprovalrealisasiSPL",
      props: true,
      component: ManifestApprovalrealisasiSPL,
      meta: {
        isPublic: true,
      },
    },
    // end public side

    {
      path: "/ChangeLogs",
      name: "ChangeLogs",
      meta: {
        isPublic: true,
      },
      component: ChangeLogs,
    },
    {
      path: "/referralFrom/:id",
      name: "ReferralFrom",
      props: true,
      meta: {
        isPublic: true,
      },
      component: ReferralFrom,
    },
  ],
});
